var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "power-add-dialog" }, [
    _c(
      "div",
      { staticClass: "dialog-body" },
      [
        _c(
          "el-form",
          {
            ref: "formPower",
            attrs: {
              "label-position": "top",
              model: _vm.formPower,
              rules: _vm.roleRules,
              "label-width": "120px"
            }
          },
          [
            _c(
              "el-form-item",
              { attrs: { label: "子系统", prop: "relations" } },
              [
                _c(
                  "el-select",
                  {
                    attrs: { size: "small", placeholder: "请选择子系统" },
                    on: {
                      change: function($event) {
                        return _vm.selectchange()
                      }
                    },
                    model: {
                      value: _vm.formPower.relations,
                      callback: function($$v) {
                        _vm.$set(_vm.formPower, "relations", $$v)
                      },
                      expression: "formPower.relations"
                    }
                  },
                  _vm._l(_vm.list, function(option) {
                    return _c("el-option", {
                      key: option.id,
                      attrs: {
                        label: option.realDictGroupName,
                        value: option.realGroupId
                      }
                    })
                  }),
                  1
                )
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "键值对组", prop: "relations" } },
              [
                _c(
                  "el-select",
                  {
                    attrs: {
                      size: "small",
                      multiple: "",
                      placeholder: "请选择键值对组"
                    },
                    on: {
                      change: function($event) {
                        return _vm.selectchange()
                      }
                    },
                    model: {
                      value: _vm.formPower.relations,
                      callback: function($$v) {
                        _vm.$set(_vm.formPower, "relations", $$v)
                      },
                      expression: "formPower.relations"
                    }
                  },
                  _vm._l(_vm.list, function(option) {
                    return _c("el-option", {
                      key: option.id,
                      attrs: {
                        label: option.realDictGroupName,
                        value: option.realGroupId
                      }
                    })
                  }),
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _c("div", { staticClass: "dialog-footer" }, [
      _c("input", {
        staticClass: "btn",
        attrs: { type: "button", value: "取消" },
        on: { click: _vm.cancelDailog }
      }),
      _c("input", {
        staticClass: "btn btn-red",
        attrs: { type: "button", value: "确认" },
        on: {
          click: function($event) {
            return _vm.commit(_vm.formPower)
          }
        }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }